import type { CurrentUser } from '@/types/api'
import type { RouteLocale } from '@/locales'

export function roleHome(user: CurrentUser, locale: RouteLocale): string {
  if (user.roles.includes('SUPER_ADMIN') || user.roles.includes('ADMIN')) {
    return `/${locale}/admin/dashboard`
  }
  if (user.roles.includes('WHOLESALE_CUSTOMER')) {
    return `/${locale}/customer/dashboard`
  }
  if (user.roles.includes('SALES_AGENT')) {
    return `/${locale}/agent/dashboard`
  }
  return `/${locale}/unauthorized`
}
